import styled from "@emotion/styled";
import theme from "../theme";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationBadge } from "./common/NotificationBadge";
import { useGetMonitoring } from "../hooks/utils/useGetMonitoring";
import { useI18n } from "../locales";

const { md, lg } = theme.screen;

type Prop = {
  activeRight?: boolean; // 사고 관제 페이지에서 오른쪽 유틸바가 활성화중인지? (sm,md)
  setActiveRight?: React.Dispatch<React.SetStateAction<boolean>>;
  isHistory?: boolean; // 과거 감지내역 조회에 사용되는지 ?
};

export const UtilBarTabButtons = ({
  activeRight,
  setActiveRight,
  isHistory,
}: Prop) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  const { data: liveData } = useGetMonitoring();
  // const liveData = queryClient.getQueryData<GetMobilityLiveList>([
  //   "Monitoring",
  // ]);

  // const { data: liveData } = useGetDetectLive({
  //   area: user?.area as string,
  //   mobility_code: -1,
  // });

  // console.log(activeRight);
  // console.log(setActiveRight);

  return (
    <TabWrapper isHistory={isHistory}>
      <LiveOperationsStyledButton
        style={{ position: "relative" }}
        activeRight={activeRight}
        isLive={location.pathname === `/`/*`/control`*/}
        onClick={() => {
          if (setActiveRight) {
            navigate(`/`/*`/control`*/);
            setActiveRight(true);
          }
          if (isHistory) {
            navigate(`/`/*`/control`*/, {
              state: { selectedTab: "realTime" },
            });
            return;
          }
        }}
      >
        {t.control.realtimeDetectionHistory}
        {typeof liveData?.list !== "undefined" &&
          liveData?.list.some(
            (el) =>
              el.accident_header_seq === 0 ||
              el.battery_status_admin === 0 ||
              el.danger_status_admin === 0 ||
              el.steal_status_admin === 0 ||
              el.userarea_status_admin === 0
          ) && <NotificationBadge />}
      </LiveOperationsStyledButton>

      <AccidentControlStyledButton
        style={{ position: "relative" }}
        isLive={location.pathname === `/`/*`/control`*/}
        activeRight={activeRight}
        onClick={() => {
          if (setActiveRight) {
            navigate(`/`/*`/control`*/);
            setActiveRight(false);
          }
          if (isHistory) {
            navigate(`/`/*`/control`*/, {
              state: { selectedTab: "mobility" },
            });
            return;
          }
        }}
      >
        {t.control.farmMachineryList}
        {typeof liveData?.list !== "undefined" &&
          liveData?.list.some(
            (el) =>
              el.accident_status_admin === 0 ||
              el.battery_status_admin === 0 ||
              el.danger_status_admin === 0 ||
              el.steal_status_admin === 0 ||
              el.userarea_status_admin === 0
          ) && <NotificationBadge />}
      </AccidentControlStyledButton>
      {/* <DetectionHistoryStyledButton
        isLive={location.pathname === `${routeId}/control`}
        onClick={() => navigate(`${routeId}/control/past`)}
      >
        과거 감지내역 조회
      </DetectionHistoryStyledButton> */}
    </TabWrapper>
  );
};

const TabWrapper = styled.div<{
  isHistory?: boolean;
}>`
  display: flex;
  padding: 20px 24px;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.color.neutral_200};

  @media (max-width: ${md}px) {
    padding: 20px 24px;
    display: ${({ isHistory }) => (isHistory ? "flex" : "none")};
    gap: 20px;
    border-bottom: 1px solid ${theme.color.neutral_200};
    top: 0;
    z-index: ${theme.zindex.tabBtnMd};
    padding: 20px 10px;
    padding-top: 5px;
    gap: 5px;
    justify-content: space-between;
    background-color: ${theme.color.neutral_50};
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    gap: 10px;
  }

  @media (min-width: ${lg + 1}px) {
    display: none;
  }
`;

// 농기계 목록
const AccidentControlStyledButton = styled.button<{
  isLive?: boolean;
  activeRight?: boolean;
}>`
  /* width: 45%; */
  height: 40px;
  background-color: ${({ /*isLive,*/ activeRight }) =>
    /*isLive &&*/ !activeRight
      ? `${theme.statusColor.MAIN}`
      : `${theme.color.neutral_200}`};
  color: ${({ /*isLive,*/ activeRight }) =>
    /*isLive &&*/ !activeRight
      ? `${theme.color.white}`
      : `${theme.color.neutral_500}`};
  border: none;
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    background: ${({ /*isLive,*/ activeRight }) =>
      /*isLive &&*/ !activeRight
        ? `${theme.statusColor.MAIN_HOVER}`
        : `${theme.color.neutral_300}`};
  }
  flex: 1;
  @media (max-width: 523px) {
    font-size: 11px;
  }

  @media (max-width: ${md}px) {
    /* width: 45%; */
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    font-size: 11px;
  }
  @media (max-width: ${lg + 1}px) {
    div {
      display: none;
    }
  }
`;

// 과거 감지내역 조회
// const DetectionHistoryStyledButton = styled.button<{ isLive?: boolean }>`
//   width: 45%;
//   height: 40px;
//   background-color: ${({ isLive }) =>
//     isLive ? `${theme.color.neutral_200}` : `${theme.statusColor.MAIN}`};
//   color: ${({ isLive }) =>
//     isLive ? `${theme.color.neutral_500}` : `${theme.color.white}`};
//   border: none;
//   font-weight: bold;
//   font-size: 15px;
//   line-height: 20px;
//   border-radius: 3px;
//   cursor: pointer;
//   &:hover {
//     background: ${({ isLive }) =>
//       isLive
//         ? `${theme.color.neutral_300}`
//         : `${theme.statusColor.MAIN_HOVER}`};
//   }

//   @media (max-width: 523px) {
//     font-size: 11px;
//   }
//   @media (max-width: ${md}px) {
//     width: 30%;
//   }
//   @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
//     font-size: 11px;
//   }
// `;

// 실시간 감지내역
const LiveOperationsStyledButton = styled.button<{
  isLive?: boolean;
  activeRight?: boolean;
}>`
  display: none;
  /* width: 45%; */
  height: 40px;
  background-color: ${({ activeRight/*, isLive*/ }) =>
    activeRight /*&& isLive*/
      ? `${theme.statusColor.MAIN}`
      : `${theme.color.neutral_200}`};
  color: ${({ activeRight }) =>
    activeRight ? `${theme.color.white}` : `${theme.color.neutral_500}`};
  border: none;
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    background: ${({ activeRight/*, isLive*/ }) =>
      activeRight /*&& isLive*/
        ? `${theme.statusColor.MAIN_HOVER}`
        : `${theme.color.neutral_300}`};
  }
  flex: 1;
  @media (max-width: 523px) {
    font-size: 11px;
  }
  @media (max-width: ${md}px) {
    display: block;
    /* width: 30%; */
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    display: block;
    font-size: 11px;
  }
  @media (min-width: ${lg + 1}px) {
    div {
      display: none;
    }
  }
`;
